import { render } from "./TxtTop.vue?vue&type=template&id=7c656c9f&scoped=true"
import script from "./TxtTop.vue?vue&type=script&lang=js"
export * from "./TxtTop.vue?vue&type=script&lang=js"

import "./TxtTop.vue?vue&type=style&index=0&id=7c656c9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c656c9f"]])

export default __exports__